import React, { useCallback, useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./knowledge.css";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import dayjs from 'dayjs';
import Select from 'react-select';
import { apiService } from '../../services/apiService';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NavigationPrompt from '../../components/Navblocker/NavigationPrompt';
import JoditEditor from 'jodit-react';
import debounce from "lodash.debounce";
import { AsyncPaginate } from 'react-select-async-paginate';
function DraftEdit() {
    const contentRef = useRef("");
    const location = useLocation();
    const currentPath = location.pathname;
    const navigate = useNavigate();
    const [authorDetail,setAuthorDetail] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [catesNames,setCateNames] = useState('');
    const [taskType, setTaskType] = useState([]);
    const [selectedCaseType, setSelectedCaseType] = useState(null);
    const [selectedCaseSubType, setSelectedCaseSubType] = useState([]);
    const [optionsKey, setOptionsKey] = useState(0);
    const [baseids, setBaseid] = useState([]);
    const [categoryId, setCategoryid] = useState([]);
    const [loading, setLoading] = useState(true);
    const [subcategoryId, setSubCategoryid] = useState([]);
    const [articleDetail, setArticleDetail] = useState([]);
    const [selectedBaseid, setSelectedBaseid] = useState(null);
    const [selectedCatId, setSelectedCategoryid] = useState(null);
    const [selectedTask, setSelectedTask] = useState(null);
    const [selectedsubCatId, setSelectedsubCategoryid] = useState(null);
    const permissionstest = JSON.parse(localStorage.getItem('permissions'));
    const roles = localStorage.getItem('role');
    // const tomorrow = dayjs().add(1, 'day');
    const [submitloader, setSubmitloader] = useState("");
    const [previewer, setPreview] = useState("false");
    // const [value, setValue] = useState(dayjs(null));
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [tags, setTags] = useState([]);
    const author_ids = Number(localStorage.getItem('userid'));
    const [backActive, setBackActive] = useState(false);
    const isAuthor = (((authorDetail && authorDetail.id === author_ids) || (permissionstest && permissionstest.manage_kba_admin === true) || (roles && roles === 'admin')) && articleDetail.status === "draft");
    const [input, setInput] = useState("");
    const [show2, setShow2] = useState(false);
    const [show3, setShow3] = useState(false);
    const handleClose2 = () => setShow2(false);
    const fetchSuggestions = async (query) => {
        if (!query) {
            setSuggestions([]); // Clear suggestions if input is empty
            return;
        }
    
        try {
            const response = await apiService.postRequest("knowledge-article/tag-suggestions", { query });
            if(response && response.success){
                setSuggestions(response.tags || []); // Adjust based on API response
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error("Error fetching suggestions:", error);
        }
    };
    
    const debouncedOnChange = debounce((value) => {
        setBackActive(true);
        const cleanValue = value === "<p><br></p>" ? "" : value;
        contentRef.current = cleanValue;
    }, 500);
    const handleInputChanger = (e) => {
        setInput(e.target.value);
        fetchSuggestions(e.target.value);
        if (errors.tags) {
            setErrors(prevErrors => ({ ...prevErrors, tags: undefined }));
        }
    };
    const handleKeyDown = (e) => {
        if (e.key === "Enter" && input.trim()) {
            e.preventDefault();
            const newTag = input.trim();
            if (!tags.includes(newTag)) {
                const updatedTags = [...tags, newTag];
                setTags(updatedTags);
    
                // Update formData's tags to a comma-separated string
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    tags: updatedTags.join(", "),
                }));
            }
            setInput("");
        }
    };
    const handleSuggestionClick = (suggestion) => {
        if (!tags.includes(suggestion)) {
          setTags([...tags, suggestion]);
        }
        setInput(""); // Clear input
        setSuggestions([]); // Hide suggestions
    };
    const removeTag = (index) => {
        const updatedTags = tags.filter((tag, i) => i !== index);
        setTags(updatedTags);
    
        // Update the formData tag property after removing the tag
        setFormData((prevFormData) => ({
            ...prevFormData,
            tags: updatedTags.join(", "), // Update to a comma-separated string
        }));
    };
    
    const [formData, setFormData] = useState({
        title: '',
        is_external: 0,
        is_preview_render: 0,
        retired_date: '',
        planned_release_date: '',
        short_description: '',
        status: '',
        task_type: '',
        tags:'',
        base_id: '',
        category_id: '',
        subcategory_id: '',
        content: '',
        case_sub_type_id:'',
        case_type_id:'',
    });
    const [settersData, setsettersData] = useState({
        title: '',
        is_external: 0,
        is_preview_render: 0,
        retired_date: '',
        planned_release_date: '',
        short_description: '',
        status: '',
        task_type: '',
        tags:'',
        base_id: '',
        category_id: '',
        subcategory_id: '',
        content: '',
        case_sub_type_id:'',
        case_type_id:'',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Clear the error for the specific field being modified
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));

        setFormData({ ...formData, [name]: value });
    };


        const [selectedOption, setSelectedOption] = useState(null);
        const [customDate, setCustomDate] = useState(null);
        const [showDatePicker, setShowDatePicker] = useState(false);
        const tomorrow = dayjs().add(1, "day").toDate(); // Min date is tomorrow
        const [isSelectActive, setIsSelectActive] = useState(false);
        // Options for dropdown
        const getOptions = () => [
            { label: "After 2 weeks", value: "2_weeks" },
            { label: "After 1 month", value: "1_month" },
            { label: "After 3 months", value: "3_months" },
            { label: "After 6 months", value: "6_months" },
            { label: "After a year", value: "1_year" },
            { label: customDate ? "On a specific date" : "On a specific date", value: "custom" },
        ];
    
        // Function to calculate retirement date
        const calculateRetirementDate = (value) => {
            const today = dayjs();
            switch (value) {
            case "2_weeks":
                return today.add(2, "week").toDate();
            case "1_month":
                return today.add(1, "month").toDate();
            case "3_months":
                return today.add(3, "month").toDate();
            case "6_months":
                return today.add(6, "month").toDate();
            case "1_year":
                return today.add(1, "year").toDate();
            default:
                return null;
            }
        };
    
        const handleOptionChange = (selected) => {
            setSelectedOption(selected);
        
            if (selected.value !== "custom") {
                const calculatedDate = calculateRetirementDate(selected.value);
                setCustomDate(null);
                
                // Update form data
                setFormData({ ...formData, retired_date: dayjs(calculatedDate).format("YYYY-MM-DD") });
        
                // Update selected option label to show the calculated date
                setSelectedOption({
                    label: `${dayjs(calculatedDate).format("YYYY-MM-DD")}`,
                    value: selected.value
                });
        
                setShowDatePicker(false);
        
                if (errors.retired_date) {
                    setErrors({ ...errors, retired_date: "" });
                }
            } else {
                setShowDatePicker(true);
            }
        };
    
        const handleDateChange = (date) => {
            if (date) {
            setCustomDate(date);
            setFormData({ ...formData, retired_date: dayjs(date).format("YYYY-MM-DD") });
    
            // Update dropdown to show the selected date
            setSelectedOption({ label: dayjs(date).format("YYYY-MM-DD"), value: "custom" });
    
            setShowDatePicker(false); // Close calendar
    
            if (errors.retired_date) {
                setErrors({ ...errors, retired_date: "" });
            }
            }
        };

    // Planned release date uses the same control as the retire date, but is
    // optional, so the dropdown is clearable
    const [plannedSelectedOption, setPlannedSelectedOption] = useState(null);
    const [plannedCustomDate, setPlannedCustomDate] = useState(null);
    const [showPlannedDatePicker, setShowPlannedDatePicker] = useState(false);
    const [isPlannedSelectActive, setIsPlannedSelectActive] = useState(false);

    const handlePlannedOptionChange = (selected) => {
        if (!selected) {
            setPlannedSelectedOption(null);
            setPlannedCustomDate(null);
            setShowPlannedDatePicker(false);
            setFormData({ ...formData, planned_release_date: "" });

            if (errors.planned_release_date) {
                setErrors({ ...errors, planned_release_date: "" });
            }
            return;
        }

        setPlannedSelectedOption(selected);

        if (selected.value !== "custom") {
            const calculatedDate = calculateRetirementDate(selected.value);
            setPlannedCustomDate(null);

            setFormData({ ...formData, planned_release_date: dayjs(calculatedDate).format("YYYY-MM-DD") });

            setPlannedSelectedOption({
                label: `${dayjs(calculatedDate).format("YYYY-MM-DD")}`,
                value: selected.value
            });

            setShowPlannedDatePicker(false);

            if (errors.planned_release_date) {
                setErrors({ ...errors, planned_release_date: "" });
            }
        } else {
            setShowPlannedDatePicker(true);
        }
    };

    const handlePlannedDateChange = (date) => {
        if (date) {
        setPlannedCustomDate(date);
        setFormData({ ...formData, planned_release_date: dayjs(date).format("YYYY-MM-DD") });

        setPlannedSelectedOption({ label: dayjs(date).format("YYYY-MM-DD"), value: "custom" });

        setShowPlannedDatePicker(false);

        if (errors.planned_release_date) {
            setErrors({ ...errors, planned_release_date: "" });
        }
        }
    };

    const { id } = useParams();

    const fetchPreviewData = useCallback(async () => {
        try {
            const response = await apiService.getRequest(`knowledge-article/${id}`);
            if (response && response.success) {
                setArticleDetail(response.data);
                setAuthorDetail(response.data.author);
                setCateNames(response.data.subcategory);
                const existingTags = response.data.tags ? response.data.tags.split(',').map(tag => tag.trim()) : [];
                setTags(existingTags);
                contentRef.current = response.data.content;
                setFormData({
                    title: response.data.title,
                    is_external: response.data.is_external || 0,
                    is_preview_render: response.data.is_preview_render || 0,
                    retired_date: response.data.retired_date,
                    planned_release_date: response.data.planned_release_date || "",
                    short_description: response.data.short_description || "",
                    status: response.data.status,
                    base_id: response.data.base.id,
                    category_id: response.data.category.id,
                    subcategory_id: response.data.subcategory.id,
                    content: response.data.content,
                    task_type: response.data.task_type || [],
                    case_type_id: response?.data?.case_types?.map(option => Number(option.id)) || [],
                    case_sub_type_id: response?.data?.case_sub_types?.map(option => Number(option.id)) || [],
                });
                setsettersData({
                    title: response.data.title,
                    is_external: response.data.is_external || 0,
                    is_preview_render: response.data.is_preview_render || 0,
                    short_description: response.data.short_description || "",
                    retired_date: response.data.retired_date,
                    planned_release_date: response.data.planned_release_date || "",
                    status: response.data.status,
                    base_id: response.data.base.id,
                    category_id: response.data.category.id,
                    subcategory_id: response.data.subcategory.id,
                    content: response.data.content,
                    task_type: response.data.task_type || [],
                    case_type_id: response?.data?.case_types?.map(option => Number(option.id)) || [],
                    case_sub_type_id: response?.data?.case_sub_types?.map(option => Number(option.id)) || [],
                });
                setSelectedOption({ label: dayjs(response.data.retired_date).format("YYYY-MM-DD"), value: "custom" });
                setPlannedSelectedOption(response.data.planned_release_date
                    ? { label: dayjs(response.data.planned_release_date).format("YYYY-MM-DD"), value: "custom" }
                    : null);
                setSelectedBaseid({
                    label: response.data.base.name,
                    value: response.data.base.id,
                });
                setSelectedCategoryid({
                    label: response.data.category.name,
                    value: response.data.category.id,
                });
                setSelectedsubCategoryid({
                    label: response.data.subcategory.name,
                    value: response.data.subcategory.id,
                });
                const selectedTasks = response.data.task_type.map(task => ({
                    label: task,
                    value: task,
                }));
                setSelectedTask(selectedTasks);

                const selectedCaseType = response.data.case_types.map(task => ({
                    label: task.name,
                    value: task.id,
                }));
                setSelectedCaseType(selectedCaseType);
                const selectedCaseSubType = response.data.case_sub_types.map(task => ({
                    label: task.name,
                    value: task.id,
                }));
                setSelectedCaseSubType(selectedCaseSubType);
            }else{
                toast.error(response.message || "Something went wrong!");
                navigate("/knowledge/draft");
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            console.error(err);
        }finally{
            setLoading(false);
        }
    }, [id,navigate]);
    useEffect(() => {
        fetchPreviewData();
    }, [fetchPreviewData]);

    console.log("FormData", formData);
    useEffect(() => {
        const isFormMatchingSetters = Object.keys(formData).every((key) => {
            const formValue = formData[key];
            const setterValue = settersData[key];
    
            if (Array.isArray(formValue) && Array.isArray(setterValue)) {
                return formValue.length === setterValue.length &&
                    formValue.every((item, index) => item === setterValue[index]);
            } else if (typeof formValue === 'object' && typeof setterValue === 'object') {
                return JSON.stringify(formValue) === JSON.stringify(setterValue);
            } else {
                return formValue === setterValue;
            }
        });
        setBackActive(!isFormMatchingSetters);
    }, [formData, settersData]);

    const handleTaskChange = (selectedOptions) => {
        setSelectedTask(selectedOptions); // Update the selected options for display
    
        // Extract values from the selected options array
        const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    
        // Update formData with the selected values (as an array)
        setFormData((prevFormData) => ({
            ...prevFormData,
            task_type: selectedValues,
        }));
    };
    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.getRequest('knowledge-bases-with-task-types');
            if (response.success) {
                setBaseid(response.data);
                setTaskType(response.taskTypes);
            }
        };
        fetchData();
    }, []);
    useEffect(() => {
        if (formData.base_id) {
            const fetchData = async () => {
                const response = await apiService.getRequest(`knowledge-article-categories-list/${formData.base_id}`);
                if (response.success) {
                    setCategoryid(response.data || []);
                    // setSelectedCategoryid(null);
                }
            };
            fetchData();
        }
    }, [formData.base_id]);

    useEffect(() => {
        if (formData.category_id) {
            const fetchData = async () => {
                const response = await apiService.getRequest(`knowledge-article-subcategories-list/${formData.category_id}`);
                if (response.success) {
                    setSubCategoryid(response.data || []);
                    // setSelectedsubCategoryid(null);
                }
            };
            fetchData();
        }
    }, [formData.category_id]);

    const handlebaseidChange = (selectedOption) => {
        setSelectedBaseid(selectedOption);
        handleInputChange({
            target: {
                name: 'base_id',
                value: selectedOption ? selectedOption.value : ''
            }
        });
        // Clear the category and subcategory when base is changed
        setSelectedCategoryid(null);
        setSelectedsubCategoryid(null);
        setCategoryid([]);
        setSubCategoryid([]);
    };

    const handleCatidChange = (selectedOption) => {
        setSelectedCategoryid(selectedOption);
        handleInputChange({
            target: {
                name: 'category_id',
                value: selectedOption ? selectedOption.value : ''
            }
        });
        setSelectedsubCategoryid(null);
        setSubCategoryid([]);
    };

    const handleSubCatidChange = (selectedOption) => {
        setSelectedsubCategoryid(selectedOption);
        handleInputChange({
            target: {
                name: 'subcategory_id',
                value: selectedOption ? selectedOption.value : ''
            }
        });
    };
    const clearDropdownOptions = () => {
        setOptionsKey(prev => prev + 1);
    };
    const loadOptions = async (searchQuery, loadedOptions, { page }) => {
        const params = {
            search: searchQuery,
            page : page
        }
        try {
        const response = await apiService.postRequest(
            `case-types/options`, params
        );
        if(response && response.success === true){
        return {
            options: response?.data?.map(item => ({
            value: item.id,
            label: item.name,
            })),
            hasMore: response?.meta?.current_page === response?.meta?.last_page ? false : true,
            additional: {
            page: page + 1,
            },
        };
        }else{
            return {
                options: [],
                hasMore: false,
            };
        }} catch (error) {
        console.error('Error loading options:', error);
        return {
            options: [],
            hasMore: false,
        };
        }
    };
    const loadOptionsSubtype = async (searchQuery, loadedOptions,  { page }) => {
        const valuesArray = selectedCaseType.map(({ value }) => Number(value));
        const params = {
            case_type_id: valuesArray,
            search: searchQuery,
            page : page,
        }
        try {
        const response = await apiService.postRequest(
            `case-sub-types/options`, params
        );
        if(response && response.success === true){
        return {
            options: response?.data?.map(item => ({
            value: item.id,
            label: item.name,
            })),
            hasMore: response?.meta?.current_page === response?.meta?.last_page ? false : true,
            additional: {
                page: page + 1,
            },
        };
        }else{
            return {
                options: [],
                hasMore: false,
            };
        }} catch (error) {
        console.error('Error loading options:', error);
        return {
            options: [],
            hasMore: false,
        };
        }
    };
    const handleCaseSubType = (selectedOptions) => {
        setSelectedCaseSubType(selectedOptions); // Update the selected options for display
    
        // Extract values from the selected options array
        const selectedValues = selectedOptions ? selectedOptions.map(option => Number(option.value)) : [];
    
        // Update formData with the selected values (as an array)
        setFormData((prevFormData) => ({
            ...prevFormData,
            case_sub_type_id: selectedValues,
        }));
        if (errors.case_sub_type_id) {
            setErrors({ ...errors, case_sub_type_id: '' });
        }
    };
    const handleCaseTypeChange = (selectedOptions) => {
        setSelectedCaseType(selectedOptions); // Update the selected options for display
        setSelectedCaseSubType([]);
        clearDropdownOptions();
        const selectedValues = selectedOptions ? selectedOptions.map(option => Number(option.value)) : [];
        // Update formData with the selected values (as an array)
        setFormData((prevFormData) => ({
            ...prevFormData,
            case_type_id: selectedValues,
            case_sub_type_id: [],
        }));
        if (errors.case_type_id) {
            setErrors({ ...errors, case_type_id: '' });
        }
    };
    const validateForm = (data) => {
        let valid = true;
        const errors = {};

        if (!formData.title || formData.title.trim() === '') {
            errors.title = 'Title is required.';
            valid = false;
        }
        if (!formData.short_description || formData.short_description.trim() === '') {
            errors.short_description = 'Description is required.';
            valid = false;
        }
        if (formData.short_description && formData.short_description.length < 3) {
            errors.short_description = "Description must be at least 3 characters long";
        }else if (formData.short_description && formData.short_description.length > 4000) {
            errors.short_description = ['Description must be less than 4000 characters long.'];
        }
        if (!formData.retired_date || formData.retired_date.trim() === '') {
            errors.retired_date = 'Retired date is required.';
            valid = false;
        } else if (!dayjs(formData.retired_date, 'YYYY-MM-DD', true).isValid()) {
            errors.retired_date = 'Invalid date format. Use YYYY-MM-DD.';
            valid = false;
        }

        if (!formData.base_id) {
            errors.base_id = 'Base ID is required.';
            valid = false;
        }

        if (!formData.category_id) {
            errors.category_id = 'Category ID is required.';
            valid = false;
        }

        if (!formData.subcategory_id) {
            errors.subcategory_id = 'Subcategory ID is required.';
            valid = false;
        }

        if (!data.content || data.content.trim() === '') {
            errors.content = 'Content is required.';
            valid = false;
        }

        if (!tags.length) {
            errors.tags = 'At least one tag is required.';
            valid = false;
        }

        setErrors(errors);
        return valid;
    };

    const handleSubmit = async (e, status, previewer,reviser) => {
        e.preventDefault();

        const contentValue = contentRef.current;
      
        const updatedFormData = {
          ...formData,
          content: contentValue,
        };

        if (!validateForm(updatedFormData)) {
            setErrorMessage('Please fix the errors before proceeding.');
            return;
        }
        setFormData(updatedFormData);
        setSubmitloader(status);
        setPreview(previewer);
        try {
            const jsonParams = {
                ...updatedFormData,
                status,
                tags: tags.join(", "), // Ensure that the tags are correctly included in the form data
                ...(reviser === "true" && { revise: true })
            };
    
            const response = await apiService.patchRequest(`knowledge-article/${id}`, jsonParams);
            if (response && response.success) {
                setErrors({});
                const isPreviewer = previewer === "true";
                setErrorMessage("");
                fetchPreviewData();
                if(isPreviewer){
                    navigate(`/knowledge/preview/${id}`)
                    toast('Article Saved to Draft successfully!');
                }else if( status === "draft" && reviser !== "true" ){
                    toast('Article Saved to Draft successfully!');
                }else if( status === "draft" && reviser === "true" ){
                    navigate('/knowledge/draft');
                    toast('Article Saved to Draft successfully!');
                }else if( status ==="under_approval" ){
                    navigate('/knowledge/under-approval');
                    toast('Article Moved to Approval successfully!');
                }else if( status ==="published" ){
                    navigate('/knowledge/published');
                    toast('Article Moved to Publish successfully!');
                }else if( status ==="retired" ){
                    navigate('/knowledge/retired');
                    toast('Article Moved to Retire successfully!');
                }
            } else {
                setErrorMessage(response.message || 'An error occurred during submission.');
                setErrors(response?.errors || {});
                toast.error(response.message || 'An error occurred during submission.');
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            setErrorMessage('Failed to submit the form. Please try again.');
        } finally {
            setSubmitloader("");
        }
    };

    const [show, setShow] = useState(false);
    const [selectedArticleId, setSelectedArticleId] = useState(null);

    const handleClose = () => setShow(false);
    const handleClose3 = () => setShow3(false);
    const handleShow = (articleId) => {
        setSelectedArticleId(articleId);
        setShow(true);
    };

    const handleDelete = async () => {
        try {
            const response = await apiService.deleteRequest(`knowledge-article/${selectedArticleId}`);
            if(response && response.success === true){
                toast(response.message);
                if(articleDetail && articleDetail.status === "draft"){
                    navigate('/knowledge/draft');
                }
                else{
                    navigate('/knowledge/retired');
                }
            }else{
                toast.error(response.message || "Failed to delete Article");
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            console.error("Failed to delete Article");
        }
        handleClose();
    };
    const styles = {
        tagContainer: {
          display: "flex",
          flexWrap: "wrap",
          padding: "0px",
          border: "none",
          borderRadius: "5px",
        },
        tag: {
          display: "flex",
          alignItems: "center",
          backgroundColor: "#B8D7FF",
          borderRadius: "3px",
          padding: "5px",
          marginRight: "5px",
          marginBottom: "5px",
          fontWeight:"600",
        },
        removeButton: {
          marginLeft: "5px",
          border: "none",
          background: "transparent",
          cursor: "pointer",
          fontSize: "16px",
        },
      };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <NavigationPrompt
                when={backActive}
                message="You have unsaved changes. Are you sure you want to leave?"
            />
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{sm:12}} container alignItems="center" className="mario_fixers_article">
                    {articleDetail && articleDetail.status === "under_approval" ? (
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Under Approval</h3>
                        <span>{catesNames.knowledge_base} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.category_name} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.name}</span>
                    </Grid>
                    ):""}
                    {articleDetail && articleDetail.status === "draft" ? (
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Draft</h3>
                        <span>{catesNames.knowledge_base} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.category_name} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.name}</span>
                    </Grid>
                    ):""}
                    {articleDetail && articleDetail.status === "published" ? (
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Published</h3>
                        <span>{catesNames.knowledge_base} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.category_name} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.name}</span>
                    </Grid>
                    ):""}
                    {articleDetail && articleDetail.status === "retired" ? (
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Retired</h3>
                        <span>{catesNames.knowledge_base} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.category_name} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.name}</span>
                    </Grid>
                    ):""}
                </Grid>
                {loading ? 
                    <div className='d-flex justify-content-center w-100 mt-5'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                <Grid size={{xs:12}} container justifyContent="flex-start" className="statusselectbtn mt-4">
                    <div className='knowledgetab_btnredirect'>
                    <Link to={`/knowledge/edit-article/${id}`}><button className={currentPath.startsWith("/knowledge/edit-article") ? "active_tabbtn" : ""} onClick={() =>{navigate(`/knowledge/edit-article/${id}`)}}>Article</button></Link>
                        {articleDetail && articleDetail.status === "draft" ? 
                        <Link to={`/knowledge/assignments/${id}`}><button>Assignment</button></Link>:
                        <Link to={`/knowledge/under-approval/show/${id}`}>
                            <button>Approvals</button>
                        </Link>
                        }
                        <Link to={`/knowledge/history/${id}`}><button >History</button></Link>
                        <Link to={`/knowledge/attachments/${id}`}><button>Attachments</button></Link>
                        <Link to={`/knowledge/discussions/${id}`}><button>Discussions</button></Link>
                        <Link to={`/knowledge/versions/${id}`}><button>Versions</button></Link>
                    </div>
                </Grid>
                <Grid size={{xs:12}} container justifyContent="space-between">
                <form className='w-100' 
                    onSubmit={handleSubmit}
                    >
                    <Grid size={{lg:12,xs:12}} container justifyContent="space-between">
                        <Grid size={{xs:12}} container justifyContent="space-between" className="darfts_inputs">
                        {articleDetail && articleDetail.status === "under_approval" ? (
                            <Grid size={{sm:12, xs:12}} container justifyContent="flex-end" className="gap-md-4 gap-2">
                                <button className='registersendbtn1' type='button' onClick={() => navigate(`/knowledge/preview/${articleDetail.id}`)}>Preview</button>
                            </Grid>
                        ):""}
                        {articleDetail && articleDetail.status === "draft" ? (
                            <Grid size={{sm:12, xs:12}} container justifyContent="flex-end" className="gap-md-4 gap-2">
                                <button style={{width:"max-content"}} className='registersendbtn2 px-4' type="submit" onClick={(e) => handleSubmit(e,"under_approval")}>{submitloader === "under_approval" ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Request for Approval'}</button>
                                <button className='registersendbtn1' type="submit" onClick={(e) => handleSubmit(e,"draft", "false")}>{(submitloader === "draft" && previewer === "false") ? <img src={require('../../assets/pinkloader.gif')} alt=''/> : 'Save'}</button>
                                <button type='button' className='registersendbtn1 px-4' onClick={() => handleShow(id)}>Delete</button>
                                <button 
                                    className="registersendbtn1"
                                    type='button'
                                    onClick={() => {
                                        if(!backActive){
                                            navigate("/knowledge/draft");
                                        }else{
                                            setShow2(true);
                                        }
                                    }}
                                    >
                                    Back
                                </button>
                                <button className='registersendbtn1' type="submit" onClick={(e) => {handleSubmit(e,(formData.status), "true")}}>{(previewer === "true") ? <img src={require('../../assets/pinkloader.gif')} alt=''/> : 'Preview'}</button>
                            </Grid>
                        ):""}
                        {articleDetail && articleDetail.status === "published" ? (
                            <Grid size={{sm:12, xs:12}} container justifyContent="flex-end" className="gap-md-4 gap-2">
                                <button className='registersendbtn1' onClick={() =>{navigate("/knowledge/published")}}>Back</button>
                                <button className='registersendbtn1' type="button"  onClick={() =>{setShow3(true)}}>Retire</button>
                                <button className='registersendbtn2 px-4' type="submit" onClick={(e) => handleSubmit(e,"draft","false","true")}>{submitloader === "draft" ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Revise'}</button>
                            </Grid>
                        ):""}
                        {articleDetail && articleDetail.status === "retired" ? (
                        <Grid size={{sm:12, xs:12}} container justifyContent="flex-end" className="gap-md-4 gap-2">
                            {articleDetail.is_auto_retired === true &&
                                <button className='registersendbtn2 px-4' type="submit" onClick={(e) => handleSubmit(e,"draft","false","true")}>{submitloader === "draft" ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Revise'}</button>
                            }
                            <button className='registersendbtn1' onClick={() =>{navigate("/knowledge/retired")}}>Back</button>
                            {permissionstest && permissionstest.manage_kba_admin === true &&
                                <button type='button' className={articleDetail.is_auto_retired === true ? "registersendbtn1 px-4" : "registersendbtn2 px-4"} onClick={() => handleShow(id)}>Delete</button>
                            }
                        </Grid>
                        ):""}
                        <Grid size={{xs:12}} container justifyContent="space-between" className="author_spans">
                            <Grid size={{sm:3.8, xs:12}} container flexDirection="column" className="author_spans">
                                <span>Author</span>
                                <h5>{authorDetail.name}</h5>
                            </Grid>
                            <Grid size={{sm:3.8, xs:12}} container flexDirection="column" className="author_spans">
                                <span>Number</span>
                                <h5>{articleDetail.format_id}</h5>
                            </Grid>
                            <Grid size={{sm:3.8, xs:12}} container flexDirection="column" className="author_spans">
                                <span>Version</span>
                                <h5>{articleDetail.current_version}</h5>
                            </Grid>
                        </Grid>
                        <Grid size={{sm:12, xs:12}} container flexDirection="column">
                            <span>Title<small>*</small></span>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                disabled={!isAuthor}
                                // onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                            />
                            {errors.title && <p style={{ color: "Red" }}>{errors.title}</p>}
                        </Grid>
                        <Grid size={{sm:5.8, xs:12}} container className="my-3" flexDirection="column">
                            <span>External</span>
                            <span className='mt-0 job_boardspancheckadd'>
                                <input type='checkbox' disabled={!isAuthor} checked={formData.is_external === 1}
                                onChange={(e) => 
                                    handleInputChange({
                                    target: { name: "is_external", value: e.target.checked ? 1 : 0 }
                                    })
                                }/>
                            External people can see this article.</span>
                            {errors.is_external && <p style={{color:"Red"}}>{errors.is_external[0]}</p>}
                        </Grid>
                        <Grid size={{sm:5.8, xs:12}} container className="my-3" flexDirection="column">
                            <span>Export PDF</span>
                            <span className='mt-0 job_boardspancheckadd'>
                                <input type='checkbox' disabled={!isAuthor} checked={formData.is_preview_render === 1}
                                onChange={(e) => 
                                    handleInputChange({
                                    target: { name: "is_preview_render", value: e.target.checked ? 1 : 0 }
                                    })
                                }/>
                            People can export this article as a PDF.</span>
                            {errors.is_preview_render && <p style={{color:"Red"}}>{errors.is_preview_render}</p>}
                        </Grid>
                        <Grid size={{sm:12, xs:12}} container flexDirection="column" className="">
                            <span>Description<small>*</small></span>
                            <textarea
                                className='textarea_community pt-1'
                                type="text"
                                minLength="3" maxLength="4001"
                                name="short_description"
                                value={formData.short_description}
                                onChange={handleInputChange}
                                disabled={!isAuthor}
                            />
                            {errors.short_description && <p style={{ color: "Red" }}>{errors.short_description}</p>}
                        </Grid>
                        <Grid size={{sm:5.8, xs:12}} style={{ position: "relative" }} container flexDirection="column">
                            <span>Retire Date<small>*</small></span>
                            <Select
                                className="basic-single select_withsearch"
                                classNamePrefix="select"
                                options={getOptions()}
                                value={selectedOption}
                                onChange={handleOptionChange}
                                isDisabled={!isAuthor}
                                placeholder="Select retirement date"
                                onFocus={() => setIsSelectActive(true)}
                                onBlur={() => setIsSelectActive(false)}
                            />

                            {/* Floating Calendar */}
                            {showDatePicker && (
                                <div style={{ position: "absolute", top: "100%", right: 0, zIndex: isSelectActive ? 0 : 1, }}>
                                <DatePicker className="react_datepickerretire"
                                    value={customDate}
                                    onChange={handleDateChange}
                                    minDate={tomorrow}
                                    clearIcon={null}
                                    autoFocus
                                    isOpen
                                />
                                </div>
                            )}
                                {errors.retired_date && <p style={{ color: "Red" }}>{errors.retired_date}</p>}
                        </Grid>
                        <Grid size={{sm:5.8, xs:12}} style={{ position: "relative" }} container flexDirection="column">
                            <span>Planned Release Date</span>
                            <Select
                                className="basic-single select_withsearch"
                                classNamePrefix="select"
                                options={getOptions()}
                                value={plannedSelectedOption}
                                onChange={handlePlannedOptionChange}
                                isDisabled={!isAuthor}
                                placeholder="Select planned release date"
                                isClearable
                                onFocus={() => setIsPlannedSelectActive(true)}
                                onBlur={() => setIsPlannedSelectActive(false)}
                            />

                            {/* Floating Calendar */}
                            {showPlannedDatePicker && (
                                <div style={{ position: "absolute", top: "100%", right: 0, zIndex: isPlannedSelectActive ? 0 : 1, }}>
                                <DatePicker className="react_datepickerretire"
                                    value={plannedCustomDate}
                                    onChange={handlePlannedDateChange}
                                    minDate={tomorrow}
                                    clearIcon={null}
                                    autoFocus
                                    isOpen
                                />
                                </div>
                            )}
                            {errors.planned_release_date && <p style={{ color: "Red" }}>{errors.planned_release_date}</p>}
                        </Grid>
                        <Grid size={{sm:5.8, xs:12}} container alignItems="flex-start" alignContent="flex-start">
                            <Grid size={{xs:12}} container flexDirection="column">
                                <span>Knowledge Base<small>*</small></span>
                                <Select
                                    className="basic-single select_withsearch"
                                    classNamePrefix="select"
                                    value={selectedBaseid}
                                    defaultValue={null}
                                    isDisabled={!isAuthor}
                                    name="base_id"
                                    options={baseids && baseids.map((state) => ({
                                        label: state.name,
                                        value: state.id,
                                    }))}
                                    onChange={handlebaseidChange}
                                />
                                {errors.base_id && <p style={{color:"Red"}}>{errors.base_id}</p>}
                            </Grid>
                            <Grid size={{xs:12}} container flexDirection="column">
                                <span>Category<small>*</small></span>
                                <Select
                                    className="basic-single select_withsearch"
                                    classNamePrefix="select"
                                    value={selectedCatId}
                                    defaultValue={null}
                                    isDisabled={!isAuthor}
                                    name="category_id"
                                    options={categoryId.map((cates) => ({
                                        label: cates.name,
                                        value: cates.id,
                                    }))}
                                    onChange={handleCatidChange}
                                />
                                {errors.category_id && <p style={{color:"Red"}}>{errors.category_id}</p>}
                            </Grid>
                            <Grid size={{xs:12}} container flexDirection="column">
                                <span>Sub Category<small>*</small></span>
                                <Select
                                    className="basic-single select_withsearch"
                                    classNamePrefix="select"
                                    value={selectedsubCatId}
                                    defaultValue={null}
                                    isDisabled={!isAuthor}
                                    name="subcategory_id"
                                    options={subcategoryId.map((subcates) => ({
                                        label: subcates.name,
                                        value: subcates.id,
                                    }))}
                                    onChange={handleSubCatidChange}
                                />
                                {errors.subcategory_id && <p style={{color:"Red"}}>{errors.subcategory_id}</p>}
                            </Grid>
                        </Grid>
                            <Grid size={{sm:5.8, xs:12}} container alignItems="flex-start" alignContent="flex-start">
                                <Grid size={{xs:12}} container flexDirection="column">
                                    <span>Select All Applicable Task Types</span>
                                    <Select
                                        isMulti
                                        className="basic-single select_withsearch"
                                        classNamePrefix="select"
                                        value={selectedTask}
                                        defaultValue={null}
                                        name="task_type"
                                        isDisabled={!isAuthor}
                                        options={taskType && taskType.map((task) => ({
                                            label: task.name,
                                            value: task.name,
                                        }))}
                                        onChange={handleTaskChange}
                                    />
                                    {errors.task_type && <p style={{color:"Red"}}>{errors.task_type}</p>}
                                </Grid>
                                <Grid size={{xs:12}} container flexDirection="column">
                                    <span>Applicable Case Types</span>
                                    <AsyncPaginate
                                        isMulti
                                        className="basic-single select_withsearch"
                                        classNamePrefix="select"
                                        name="case_type_id"
                                        isDisabled={!isAuthor}
                                        loadOptions={loadOptions}
                                        value={selectedCaseType}
                                        additional={{
                                            page: 1,
                                        }}
                                        debounceTimeout={300}
                                        onChange={handleCaseTypeChange}
                                        isClearable
                                        cacheUniqs={[]}
                                        reduceOptions={(prevOptions, loadedOptions) => [...prevOptions, ...loadedOptions]} 
                                    />
                                    {errors.case_type_id && <p style={{color:"Red"}}>{errors.case_type_id}</p>}
                                </Grid>
                                {selectedCaseType?.length > 0 &&
                                <Grid size={{xs:12}} container flexDirection="column">
                                    <span>Applicable Case Sub Types</span>
                                    <AsyncPaginate
                                        key={optionsKey}
                                        isMulti
                                        className="basic-single select_withsearch"
                                        classNamePrefix="select"
                                        name="case_sub_type_id"
                                        isDisabled={!isAuthor}
                                        loadOptions={loadOptionsSubtype}
                                        value={selectedCaseSubType}
                                        additional={{
                                            page: 1,
                                        }}
                                        debounceTimeout={300}
                                        onChange={handleCaseSubType}
                                        isClearable
                                        cacheUniqs={[]}
                                        reduceOptions={(prevOptions, loadedOptions) => [...prevOptions, ...loadedOptions]}
                                    />
                                    {errors.case_sub_type_id && <p style={{color:"Red"}}>{errors.case_sub_type_id}</p>}
                                </Grid>}
                            </Grid>
                        </Grid>
                        <Grid size={{xs:12}} container className={!isAuthor ? "mt-5 texteditor_iframe editor_sunsinput":"mt-5 editor_sunsinput"}>
                        <JoditEditor
                            value={formData.content}
                            config={{
                                pasteHTML: '', // default paste content
                                cleanHTML: false,
                                askBeforePasteHTML: false,
                                askBeforePasteFromWord: false,
                                disablePlugins: ['pasteStorage'], // optionally disable paste-related cleanup plugins
                                iframe: false, // make sure iframe is off
                                editHTMLDocumentMode: false,
                                enableDragAndDropFileToEditor: false,
                                processPasteHTML: html => {
                                return html.replace(/</g, '&lt;').replace(/>/g, '&gt;');
                                },
                                enter: 'BR',
                                beautifyHTML: false,
                                events: {
                                    onPaste: (event) => {
                                        console.log("Pasted!", event);
                                    },
                                },
                                paste: {
                                cleanOnPaste: false,
                                replaceNewlines: false
                                },
                                controls: {
                                    videoUpload: {
                                        name: "videoUpload",
                                        tooltip: "Insert Video by URL",
                                        icon: "video",
                                        exec: (editor) => {
                                            const formDiv = editor.create.fromHTML(`
                                            <div style="padding: 20px; min-width: 400px;">
                                                <h3 style="margin: 0 0 15px 0; color: #333;">Insert Video URL</h3>
                                                <div style="margin-bottom: 15px;">
                                                <label style="display: block; margin-bottom: 5px; font-weight: 600; color: #555;">
                                                    Video URL <span style="color: red;">*</span>
                                                </label>
                                                <input 
                                                    type="text" 
                                                    id="videoUrlInput" 
                                                    placeholder="https://example.com/video.mp4" 
                                                    style="width: 100%; padding: 10px; border: 2px solid #ddd; border-radius: 6px; font-size: 14px; box-sizing: border-box;"
                                                />
                                                <small style="color: #666; font-size: 12px; display: block; margin-top: 5px;">
                                                    Supported formats: MP4, WebM, OGG
                                                </small>
                                                </div>
                                                
                                                <div style="margin-bottom: 15px;">
                                                <label style="display: block; margin-bottom: 5px; font-weight: 600; color: #555;">
                                                    Width (optional)
                                                </label>
                                                <input 
                                                    type="text" 
                                                    id="videoWidthInput" 
                                                    placeholder="640px or 100%" 
                                                    value="300px"
                                                    style="width: 100%; padding: 10px; border: 2px solid #ddd; border-radius: 6px; font-size: 14px; box-sizing: border-box;"
                                                />
                                                </div>
                                                
                                                <div style="margin-bottom: 20px;">
                                                <label style="display: flex; align-items: center; cursor: pointer;">
                                                    <input 
                                                    type="checkbox" 
                                                    id="autoplayCheck"
                                                    style="margin-right: 8px; width: 18px; height: 18px; cursor: pointer;"
                                                    />
                                                    <span style="color: #555; font-size: 14px;">Autoplay video</span>
                                                </label>
                                                </div>
                                                
                                                <div style="display: flex; gap: 10px; justify-content: flex-end;">
                                                <button 
                                                    type="button" 
                                                    id="cancelVideoBtn" 
                                                    style="padding: 10px 20px; border: 2px solid #ddd; background: white; border-radius: 6px; cursor: pointer; font-weight: 600; color: #666; transition: all 0.2s;"
                                                >
                                                    Cancel
                                                </button>
                                                <button 
                                                    type="button" 
                                                    id="insertVideoBtn" 
                                                    style="padding: 10px 20px; border: none; background: #4CAF50; color: white; border-radius: 6px; cursor: pointer; font-weight: 600; transition: all 0.2s;"
                                                >
                                                    Insert Video
                                                </button>
                                                </div>
                                            </div>
                                            `);

                                            const urlInput = formDiv.querySelector('#videoUrlInput');
                                            const widthInput = formDiv.querySelector('#videoWidthInput');
                                            const autoplayCheck = formDiv.querySelector('#autoplayCheck');
                                            const insertBtn = formDiv.querySelector('#insertVideoBtn');
                                            const cancelBtn = formDiv.querySelector('#cancelVideoBtn');

                                            const dialog = editor.alert(formDiv, 'Insert Video');
                                            
                                            setTimeout(() => urlInput.focus(), 100);

                                            insertBtn.onclick = () => {
                                            const url = urlInput.value.trim();
                                            
                                            if (!url) {
                                                urlInput.style.borderColor = 'red';
                                                urlInput.focus();
                                                return;
                                            }

                                            if (!url.match(/^https?:\/\/.+/i)) {
                                                editor.alert('Please enter a valid URL starting with http:// or https://');
                                                urlInput.style.borderColor = 'red';
                                                urlInput.focus();
                                                return;
                                            }

                                            const width = widthInput.value.trim() || '100%';
                                            const autoplay = autoplayCheck.checked;
                                            
                                            let videoType = 'video/mp4';
                                            if (url.match(/\.webm(\?.*)?$/i)) videoType = 'video/webm';
                                            else if (url.match(/\.ogg(\?.*)?$/i)) videoType = 'video/ogg';
                                            else if (url.match(/\.mov(\?.*)?$/i)) videoType = 'video/mp4';

                                            const videoHTML = `
                                                <p>
                                                <video 
                                                    controls 
                                                    controlsList="nodownload" 
                                                    ${autoplay ? 'autoplay muted' : ''} 
                                                    width="${width}" 
                                                    style="max-width: 100%; height: auto; display: block;"
                                                >
                                                    <source src="${url}" type="${videoType}">
                                                    Your browser does not support the video tag.
                                                </video>
                                                </p>
                                            `;

                                            editor.selection.insertHTML(videoHTML);
                                            dialog.close();
                                            };

                                            cancelBtn.onclick = () => {
                                            dialog.close();
                                            };

                                            insertBtn.onmouseenter = () => {
                                            insertBtn.style.background = '#45a049';
                                            };
                                            insertBtn.onmouseleave = () => {
                                            insertBtn.style.background = '#4CAF50';
                                            };
                                            
                                            cancelBtn.onmouseenter = () => {
                                            cancelBtn.style.background = '#f5f5f5';
                                            };
                                            cancelBtn.onmouseleave = () => {
                                            cancelBtn.style.background = 'white';
                                            };

                                            urlInput.onkeypress = (e) => {
                                            if (e.key === 'Enter') {
                                                insertBtn.click();
                                            }
                                            };
                                        }
                                    },
                                    video: {
                                        name: 'video',
                                        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M581.7 188.1C575.5 164.4 556.9 145.8 533.4 139.5C490.9 128 320.1 128 320.1 128C320.1 128 149.3 128 106.7 139.5C83.2 145.8 64.7 164.4 58.4 188.1C47 231 47 320.4 47 320.4C47 320.4 47 409.8 58.4 452.7C64.7 476.3 83.2 494.2 106.7 500.5C149.3 512 320.1 512 320.1 512C320.1 512 490.9 512 533.5 500.5C557 494.2 575.5 476.3 581.8 452.7C593.2 409.8 593.2 320.4 593.2 320.4C593.2 320.4 593.2 231 581.8 188.1zM264.2 401.6L264.2 239.2L406.9 320.4L264.2 401.6z"/></svg>',
                                        tooltip: 'Insert youtube video'
                                    },
                                    image: {
                                        name: 'image',
                                        icon: 'file',
                                        tooltip: 'Insert file'
                                    },
                                    font: {
                                        list: {
                                            'calibri': 'Calibri'
                                        }
                                    },
                                    removeFormat: {
                                        name: 'removeFormat',
                                        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M178.5 416l123 0 65.3-65.3-173.5-173.5-126.7 126.7 112 112zM224 480l-45.5 0c-17 0-33.3-6.7-45.3-18.7L17 345C6.1 334.1 0 319.4 0 304s6.1-30.1 17-41L263 17C273.9 6.1 288.6 0 304 0s30.1 6.1 41 17L527 199c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41l-135 135 120 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0z"/></svg>',
                                        tooltip: 'Remove Format',
                                    },
                                    insertCodeBlock: {
                                        name: 'insertCodeBlock',
                                        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M64 96c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 256-64 0 0-256L128 96l0 256-64 0L64 96zM0 403.2C0 392.6 8.6 384 19.2 384l601.6 0c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8L76.8 480C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 175l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"/></svg>',
                                        tooltip: 'Insert Code Block',
                                        exec: (editor) => {
                                            const codeBlockHTML = `
                                                <div class="code-block-container"  style="margin: 10px 0; padding: 10px; background-color: #f5f5f5; border: 1px solid #ddd; border-radius: 4px;">
                                                    <div class="code-block-editor" contenteditable="true" data-jodit-temp="false" style="font-family: monospace; white-space: pre; overflow-x: auto;">// Type or paste your code here and Result of the code will be shown next to the code</div>
                                                </div>
                                            `;
                                            
                                            
                                            const currentSelection = editor.s.current();
                                            let currentCodeBlock = null;
                                            
                                            let node = currentSelection;
                                            while (node && node !== editor.editor) {
                                                if (node.classList && 
                                                    (node.classList.contains('code-block-editor') || 
                                                     node.classList.contains('code-block-container'))) {
                                                    currentCodeBlock = node.classList.contains('code-block-container') ? 
                                                        node : node.closest('.code-block-container');
                                                    break;
                                                }
                                                node = node.parentNode;
                                            }
                                            
                                            if (currentCodeBlock) {
                                                let resultParagraph = currentCodeBlock.nextElementSibling;
                                                
                                                if (resultParagraph && resultParagraph.tagName === 'P' && 
                                                    resultParagraph.textContent === 'Result') {
                                                        
                                                    editor.s.setCursorAfter(resultParagraph);
                                                    editor.s.insertHTML(codeBlockHTML);
                                                } else {
                                                    editor.s.setCursorAfter(currentCodeBlock);
                                                    editor.s.insertHTML(codeBlockHTML);
                                                }
                                            } else {
                                                editor.s.insertHTML(codeBlockHTML);
                                            }
                                            
                                            const codeBlocks = editor.editor.querySelectorAll('.code-block-editor');
                                            const newCodeBlockEditor = codeBlocks[codeBlocks.length - 1];
                                            
                                            if (newCodeBlockEditor) {
                                                const handleCodeInput = function() {
                                                    const plainText = this.innerText || this.textContent;
                                                    
                                                    this.innerHTML = plainText
                                                        .replace(/&/g, '&amp;')
                                                        .replace(/</g, '&lt;')
                                                        .replace(/>/g, '&gt;');
                                                };
                                                newCodeBlockEditor.addEventListener('paste', function(e) {
                                                    e.preventDefault();
                                                    
                                                    const text = e.clipboardData.getData('text/plain');
                                                    
                                                    const selection = window.getSelection();
                                                    const range = selection.getRangeAt(0);
                                                    range.deleteContents();
                                                    range.insertNode(document.createTextNode(text));
                                                    
                                                    handleCodeInput.call(this);
                                                    
                                                    range.setStartAfter(range.endContainer);
                                                    range.collapse(true);
                                                    selection.removeAllRanges();
                                                    selection.addRange(range);
                                                });
                                                
                                                newCodeBlockEditor.addEventListener('input', function() {
                                                    handleCodeInput.call(this);
                                                });
                                                
                                                newCodeBlockEditor.focus();
                                                const selection = window.getSelection();
                                                const range = document.createRange();
                                                range.selectNodeContents(newCodeBlockEditor);
                                                selection.removeAllRanges();
                                                selection.addRange(range);
                                            }
                                        }
                                    },
                                    removeBg: {
                                        name: "removeBg",
                                        tooltip: "Remove Background Color",
                                        icon: "eraser",
                                        exec: (editor) => {
                                        editor.s.focus();
                                    
                                        const sel = editor.s.sel;
                                        if (sel && sel.rangeCount > 0) {
                                            const range = sel.getRangeAt(0);
                                            const contents = range.cloneContents();
                                            const div = editor.ownerDocument.createElement("div");
                                            div.appendChild(contents);
                                    
                                            // Remove background-color from all styles in selection
                                            const elements = div.querySelectorAll("*");
                                            elements.forEach(el => {
                                            if (el.style && el.style.backgroundColor) {
                                                el.style.backgroundColor = "";
                                            }
                                            });
                                    
                                            // Replace selected HTML with cleaned version
                                            editor.selection.remove();
                                            editor.selection.insertHTML(div.innerHTML);
                                        }
                                        }
                                    },
                                    fontsize: {
                                        list: {
                                        "12px": "Paragraph - 12",
                                        "14px": "Small - 14",
                                        "16px": "Default - 16",
                                        "18px": "Medium - 18",
                                        "24px": "Large - 24"
                                        }
                                    },                                              
                                },
                                width: "100%",
                                minWidth: "500px",
                                readonly: !isAuthor,
                                toolbarAdaptive: false,
                                toolbarSticky: false,
                                uploader: {
                                    insertImageAsBase64URI: true,
                                    url: '/upload-image',
                                    filesVariableName: () => 'image',
                                    accept: 'image/*',

                                    onSelect: function (files, handler) {
                                    const validImages = [];
                                    for (let file of files) {
                                        if (file.type.startsWith('image/')) {
                                        validImages.push(file);
                                        } else {
                                            this.jodit.alert(`Only image formats are allowed: ${file.name}`, 'error');
                                        }
                                    }

                                    if (validImages.length > 0) {
                                        handler(validImages);
                                    }
                                    },

                                    error: function (e) {
                                    this.jodit.alert('❌ Only image files are allowed or upload failed.', 'error');
                                    }
                                },
                                buttons: [
                                    "source", 'insertCodeBlock',"|",
                                    "bold", "italic", "underline", "strikethrough","spellcheck", "|",
                                    "fontsize", "brush","removeBg", "|", // Font size, font style, text color // "font",
                                    "ul", "ol", "|",
                                    "align", "|",
                                    "image", "videoUpload", "video", "table", "link", "|",
                                    "undo", "redo", "removeFormat", "|",
                                    "hr", "fullsize" // Additional options
                                ],
                                useIframe: false,
                                defaultFont: "calibri", // Default font
                                style: {
                                    fontFamily: "calibri", // Set font globally
                                },
                                showCharsCounter: false, // Hides character counter
                                showWordsCounter: false, // Hides word counter
                            }}
                            onChange={debouncedOnChange}
                        />
                            {errors.content && <p style={{color:"Red"}}>{errors.content}</p>}
                        </Grid> 
                        <Grid size={{sm:12, xs:12}} container flexDirection="column" className="darfts_inputs" style={{position:"relative"}}>
                        <span>Tag<small>*</small></span>
                        <input
                            type="text"
                            disabled={!isAuthor}
                            value={input}
                            onChange={handleInputChanger}
                            onKeyDown={handleKeyDown}
                            placeholder="Type and press Enter"
                            style={styles.input}
                        />
                        {suggestions.length > 0 && input.trim() !== "" && (
                            <ul style={{ 
                                listStyle: "none", 
                                padding: "5px", 
                                border: "1px solid #ccc", 
                                borderRadius: "4px", 
                                margin: 0, 
                                position: "absolute", 
                                top:"100%",
                                background: "#fff", 
                                width: "250px",
                                height:"150px",
                                overflow:"auto",
                                zIndex: 10, 
                            }}>
                                {suggestions.map((tag, index) => (
                                    <li 
                                        key={index} 
                                        style={{ padding: "5px", cursor: "pointer" }} 
                                        onClick={() => handleSuggestionClick(tag)}
                                    >
                                        {tag}
                                    </li>
                                    ))}
                                </ul>
                            )}
                        <div style={styles.tagContainer}>
                            {tags && tags.map((tag, index) => (
                            <div key={index} style={styles.tag}>
                                {tag}
                                <button
                                type="button"
                                style={styles.removeButton}
                                onClick={() => removeTag(index)}
                                disabled={!isAuthor}
                                >
                                &times;
                                </button>
                            </div>
                            ))}
                        </div>
                        {errors.tags && <p style={{color:"Red"}}>{errors.tags}</p>}
                        </Grid>
                        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                        
                        {articleDetail && articleDetail.status === "under_approval" ? (
                            <Grid size={{sm:12, xs:12}} container justifyContent="flex-start" className="gap-md-4 gap-2">
                                <button className='registersendbtn1' type='button' onClick={() => navigate(`/knowledge/preview/${articleDetail.id}`)}>Preview</button>
                            </Grid>
                        ):""}
                        {articleDetail && articleDetail.status === "draft" ? (
                            <Grid size={{sm:12, xs:12}} container justifyContent="flex-start" className="gap-md-4 gap-2">
                                <button style={{width:"max-content"}} className='registersendbtn2 px-4' type="submit" onClick={(e) => handleSubmit(e,"under_approval")}>{submitloader === "under_approval" ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Request for Approval'}</button>
                                <button className='registersendbtn1' type="submit" onClick={(e) => handleSubmit(e,"draft", "false")}>{(submitloader === "draft" && previewer === "false") ? <img src={require('../../assets/pinkloader.gif')} alt=''/> : 'Save'}</button>
                                <button type='button' className='registersendbtn1 px-4' onClick={() => handleShow(id)}>Delete</button>
                                {/* <button className='registersendbtn1' onClick={() =>{navigate("/knowledge/draft")}}>Back</button> */}
                                <button
                                    className="registersendbtn1"
                                    type='button'
                                    onClick={() => {
                                        if(!backActive){
                                            navigate("/knowledge/draft");
                                        }else{
                                            setShow2(true);
                                        }
                                    }}
                                    >
                                    Back
                                    </button>
                                <button className='registersendbtn1' type="submit" onClick={(e) => {handleSubmit(e,(formData.status), "true")}}>{(previewer === "true") ? <img src={require('../../assets/pinkloader.gif')} alt=''/> : 'Preview'}</button>
                            </Grid>
                        ):""}
                        {articleDetail && articleDetail.status === "published" ? (
                            <Grid size={{sm:12, xs:12}} container justifyContent="flex-start" className="gap-md-4 gap-2">
                                <button className='registersendbtn1' onClick={() =>{navigate("/knowledge/published")}}>Back</button>
                                <button className='registersendbtn1' type="button"  onClick={() =>{setShow3(true)}}>Retire</button>
                                <button className='registersendbtn2 px-4' type="submit" onClick={(e) => handleSubmit(e,"draft","false","true")}>{submitloader === "draft" ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Revise'}</button>
                            </Grid>
                        ):""}
                        {articleDetail && articleDetail.status === "retired" ? (
                        <Grid size={{sm:12, xs:12}} container justifyContent="flex-start" className="gap-md-4 gap-2">
                            {articleDetail.is_auto_retired === true &&
                                <button className='registersendbtn2 px-4' type="submit" onClick={(e) => handleSubmit(e,"draft","false","true")}>{submitloader === "draft" ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Revise'}</button>
                            }
                            <button className='registersendbtn1' onClick={() =>{navigate("/knowledge/retired")}}>Back</button>
                            {permissionstest && permissionstest.manage_kba_admin === true &&
                                <button type='button' className={articleDetail.is_auto_retired === true ? "registersendbtn1 px-4" : "registersendbtn2 px-4"} onClick={() => handleShow(id)}>Delete</button>
                            }
                        </Grid>
                        ):""}
                    </Grid>
                </form>
                </Grid>
                </>}
            </Grid>
            <Modal
                show={show2} 
                onHide={handleClose2}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton style={{border:"none"}}>
                    <h4 className='mb-0'>Leave Page</h4>
                </Modal.Header>
                <Modal.Body>
                <div className="d-flex w-100 flex-column modal_register">
                    <h5>Do you want to save changes before leaving this page?</h5>
                    <p>Your changes will be lost if you leave now.</p>
                </div>
                </Modal.Body>
                <Modal.Footer>
                <button className='blue_primarymodalbtn1' onClick={handleClose2}>
                    Cancel
                </button>
                <button className='blue_primarymodalbtn2' onClick={() => navigate("/knowledge/draft")}>
                    Leave
                </button>
                </Modal.Footer>
            </Modal>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this Article?</Modal.Body>
                <Modal.Footer>
                    <button className='modal_cancel' onClick={handleClose}>
                        Cancel
                    </button>
                    <button className='modal_delete' onClick={handleDelete}>
                        Delete
                    </button>
                </Modal.Footer>
            </Modal>
            <Modal show={show3} onHide={handleClose3}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Retire</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to retire this Article?</Modal.Body>
                <Modal.Footer>
                    <button className='registersendbtn1 my-0 me-3' onClick={handleClose3}>
                        Cancel
                    </button>
                    <button className='registersendbtn2 my-0' onClick={(e) => handleSubmit(e,"retired", "false")}>
                    {(submitloader === "retired") ? <img src={require('../../assets/pinkloader.gif')} alt=''/> : 'Confirm'}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    </div>
  )
}

export default DraftEdit
